import { render } from "./cms-html-code-editor.vue?vue&type=template&id=2f98acc3"
import script from "./cms-html-code-editor.vue?vue&type=script&lang=js"
export * from "./cms-html-code-editor.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__